/*
 * @Author: your name
 * @Date: 2020-10-13 14:28:22
 * @LastEditTime: 2022-11-15 16:59:20
 * @LastEditors: pj
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\store\modules\devicelog\devicelog.js
 */
import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        messageServiceList: [],
        passwayTypeList: [],
        platformtypeList: [],
    },

    getters: {
    },

    mutations: {
        save (state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
        // 渠道管理
        querychannelone (context, payload) {
            return D.select({
                ...payload
            })
        },
        querychannels (context, payload) {
            return D.select({
                ...payload
            })
        },
        querychannelpage (context, payload) {
            return D.select({
                ...payload
            })
        },
        addchannel (context, payload) {
            return D.add({
                ...payload
            })
        },
        updatechannel (context, payload) {
            return D.edit({
                ...payload
            })
        },

        deletechannel (context, payload) {
            return D.del({
                ...payload
            })
        },
        selectRelatedPassways (context, payload) {
            return D.select({
                ...payload
            })
        },
        saveRelatedPassways (context, payload) {
            return D.add({
                ...payload
            })
        },

        // 通道管理
        querypasswayone (context, payload) {
            return D.select({
                ...payload
            })
        },
        querypassways (context, payload) {
            return D.select({
                ...payload
            })
        },
        querypasswaypage (context, payload) {
            return D.select({
                ...payload
            })
        },
        addpassway (context, payload) {
            return D.add({
                ...payload
            })
        },
        updatepassway (context, payload) {
            return D.edit({
                ...payload
            })
        },
        deletepassway (context, payload) {
            return D.del({
                ...payload
            })
        },

        selectauthchannel (context, payload) {
            return D.select({
                ...payload
            })
        },

        updateauthchannel (context, payload) {
            return D.edit({
                ...payload
            })
        },

        // // 设备列表
        // querypasswaychannelone(context, payload) {
        //     return D.select({
        //         ...payload
        //     })
        // },
        // querypasswaychannels(context, payload) {
        //     return D.select({
        //         ...payload
        //     })
        // },
        // querypasswaychannelpage(context, payload) {
        //     return D.select({
        //         ...payload
        //     })
        // },
        // addpasswaychannel(context, payload) {
        //     return D.add({
        //         ...payload
        //     })
        // },
        updatepasswaychannel (context, payload) {
            return D.edit({
                ...payload
            })
        },


        // 用户
        querytargetgroupsone (context, payload) {
            return D.select({
                ...payload
            })
        },

        querytargetgroupspage (context, payload) {
            return D.select({
                ...payload
            })
        },
        addtargetgroups (context, payload) {
            return D.add({
                ...payload
            })
        },
        updatetargetgroups (context, payload) {
            return D.edit({
                ...payload
            })
        },

        deletetargetgroup (context, payload) {
            return D.del({
                ...payload
            })
        },

        //消息模板相关

        querytempleteone (context, payload) {
            return D.select({
                ...payload
            })
        },
        querytempletes (context, payload) {
            return D.select({
                ...payload
            })
        },
        deletetempletes (context, payload) {
            return D.del({
                ...payload
            })
        },
        querytempletepage (context, payload) {
            return D.select({
                ...payload
            })
        },
        addtemplete (context, payload) {
            return D.add({
                ...payload
            })
        },
        updatetemplete (context, payload) {
            return D.edit({
                ...payload
            })
        },

        //平台列表
        platforms (context, payload) {
            return D.select({
                ...payload
            })
        },


        //发送消息
        getpasswaybychannel (context, payload) {
            return D.select({
                ...payload
            })
        },
        configmessage (context, payload) {
            return D.add({
                ...payload
            })
        },
        savemessage (context, payload) {
            return D.add({
                ...payload
            })
        },
        savemessageapi (context, payload) {
            return D.add({
                ...payload
            })
        },
        querymessagepage (context, payload) {
            return D.select({
                ...payload
            })
        },
        querypasswaytypes (context, payload) {
            return D.select({
                ...payload
            })
        },

        //消息记录
        selectMcmsMessageRecordsPage (context, payload) {
            return D.select({
                ...payload
            })
        },

        //业务类型

        selectMcmsMessageServices (context, payload) {


            return D.select({
                ...payload
            })
        },
        selectMcmsMessageServicesOne (context, payload) {
            return D.select({
                ...payload
            })
        },
        selectMcmsMessageServicesPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        deleteMcmsMessageServices (context, payload) {
            return D.del({
                ...payload
            })
        },
        insertMcmsMessageService (context, payload) {
            return D.add({
                ...payload
            })
        },
        updateMcmsMessageService (context, payload) {
            return D.edit({
                ...payload
            })
        },
        //通道类型

        selectMcmsPasswaytypes (context, payload) {
            return D.select({
                ...payload
            })
        },
        selectMcmsPasswaytypesOne (context, payload) {
            return D.select({
                ...payload
            })
        },
        selectMcmsPasswaytypesPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        deleteMcmsPasswaytypes (context, payload) {
            return D.del({
                ...payload
            })
        },
        insertMcmsPasswaytype (context, payload) {
            return D.add({
                ...payload
            })
        },
        updateMcmsPasswaytype (context, payload) {
            return D.edit({
                ...payload
            })
        },

        //业务类型

        selectMcmsPlatformtypes (context, payload) {
            return D.select({
                ...payload
            })
        },
        selectMcmsPlatformtypesOne (context, payload) {
            return D.select({
                ...payload
            })
        },
        selectMcmsPlatformtypesPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        deleteMcmsPlatformtypes (context, payload) {
            return D.del({
                ...payload
            })
        },
        insertMcmsPlatformtype (context, payload) {
            return D.add({
                ...payload
            })
        },
        updateMcmsPlatformtype (context, payload) {
            return D.edit({
                ...payload
            })
        },

        querymsghistoryv3page (context, payload) {
            return D.select({
                ...payload
            })
        },
        querymsghistorypage (context, payload) {
            return D.select({
                ...payload
            })
        },
        querydevicev3page (context, payload) {
            return D.select({
                ...payload
            })
        },
        querydevicepage (context, payload) {
            return D.select({
                ...payload
            })
        },
        sendmsgv3thistory (context, payload) {
            return D.select({
                ...payload
            })
        },
        sendmsgthistory (context, payload) {
            return D.select({
                ...payload
            })
        },
        analysisResult (context, payload) {
            return D.select({
                ...payload
            })
        },
        //消息统计图表
        queryReadCt (context, payload) {
            return D.select({
                ...payload
            })
        },
        queryTouchCt (context, payload) {
            return D.select({
                ...payload
            })
        },

        //业务分类
        mcmsmessagetypeQuery (context, payload) {
            return D.select({
                ...payload
            })
        },
        mcmsmessagetypeAdd (context, payload) {
            return D.add({
                ...payload
            })
        },
        mcmsmessagetypeDel (context, payload) {
            return D.del({
                ...payload
            })
        },
        mcmsmessagetypeEdit (context, payload) {
            return D.edit({
                ...payload
            })
        },

        v3deleteDevice (context, payload) {
            return D.del({
                ...payload
            })
        },

        deleteDevice (context, payload) {
            return D.del({
                ...payload
            })
        },
        queryListByChannelCode (context, payload) {
            return D.select({
                ...payload
            })
        },
        queryMessageSendByType (context, payload) {
            return D.select({
                ...payload
            })
        },
        queryMessageSendByStatus (context, payload) {
            return D.select({
                ...payload
            })
        },

        querySendMsgCt (context, payload) {
            return D.select({
                ...payload
            })
        },

        resendMcmsMessageRecord (context, payload) {
            return D.edit({
                ...payload
            })
        },

        queryWebsocketoIpstatPageList (context, payload) {
            return D.select({
                ...payload
            })
        },

        queryWebsocketoIpstatDetailPageList (context, payload) {
            return D.select({
                ...payload
            })
        },

    }
}
